import { Injectable, Inject } from "@angular/core";
import { HTTP_CONFIG } from './http-function-token';
import { HttpToken } from './http-function-token-class';

@Injectable()
export class HttpFunctionService {

  constructor(@Inject(HTTP_CONFIG) private config: any) {
    HttpToken.config = Object.assign({}, config);
  }
}
